import { Component, Inject, OnDestroy } from '@angular/core';
import { Md5 } from 'ts-md5';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserValidationRequest } from '../models/UserValidationRequest.model';
import { takeUntil } from 'rxjs/operators';
import { RequestService } from '../services/request.service';
import { UserValidationResult } from '../models/UserValidationResult.model';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnDestroy {
  form: FormGroup;
  errors: string[] = [];
  button1: string = "Cancel";
  button2: string = "Save";
  title: string = "Settings";
  isPasswordVisible: boolean = false;
  isPasswordRepeatVisible: boolean = false;
  private unscubscribe$ = new Subject<void>();

  constructor(
    private requestService: RequestService,
    private dialogRef: MatDialogRef<SettingsComponent>,
    @Inject(MAT_DIALOG_DATA) private data: { email: string }) {
    this.form = new FormGroup({
      password: new FormControl(null, Validators.required),
      repeatPassword: new FormControl(null, Validators.required)
    });
    this.dialogRef.disableClose = true;
  }

  overridePassword() {
    var password = this.form.get('password').value;
    var repeatPassword = this.form.get('repeatPassword').value;

    let userValidationRequest: UserValidationRequest = {
      email: null,
      password: password,
      repeatPassword: repeatPassword,
      companyId: -1
    };

    this.requestService.validateUser(userValidationRequest).pipe(takeUntil(this.unscubscribe$))
      .subscribe((response: UserValidationResult) => {
        if (response.success) {
          const md5 = new Md5();
          let hashedPw: string = md5.appendStr(password).end().toString();

          this.dialogRef.close({ save: true, data: { password: hashedPw, email: this.data.email } });
        }
        else {
          this.errors = response.errors;
        }
      });
  }

  visibilityPassword() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  visibilityPasswordRepeat() {
    this.isPasswordRepeatVisible = !this.isPasswordRepeatVisible;
  }

  cancel() {
    this.dialogRef.close({ save: false, data: null });
  }

  ngOnDestroy(): void {
    this.unscubscribe$.next();
    this.unscubscribe$.complete();
  }
}
